import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react";

import { HOME as HOME_ROUTE, SSO_AUTH_ERROR} from 'src/routes/routes';
import authToken from 'src/utils/auth';
import { useUserClientQuery } from 'src/hooks/user';
import { ProcessingRequestScreen } from 'src/components/SSOScreens/ProcessingRequestScreen';

const Auth0CallbackPage = () => {
  const {
    isAuthenticated,
    getAccessTokenSilently,
    error
  } = useAuth0();
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [isTokenFetched, setIsTokenFetched] = useState(false);

  const getUser = useUserClientQuery();
  
  useEffect(() =>{
    if(error){
      setRedirectUrl(`${SSO_AUTH_ERROR}?error=${error.error}&error_description=${error.error_description}`);
    }
  }, [error])

  useEffect(() => {
    if (isTokenFetched) {
      setRedirectUrl(HOME_ROUTE)
    }
  }, [isTokenFetched]);

  useEffect(() => {
    const fetchAccessTokenAndUser = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        if (accessToken) {
          authToken({accessToken});
          const { data } = await getUser();
          const token = { accessToken, user: data?.user, refreshToken: accessToken };
          authToken(token);
          setIsTokenFetched(true);
        }
      } catch (err) {
        console.error("Error while fetching auth0 access token", err);
      }
    };

    if (isAuthenticated) {
      fetchAccessTokenAndUser();
    }
  }, [isAuthenticated]);

  return (redirectUrl ? 
    <Redirect to={redirectUrl} /> : 
    <ProcessingRequestScreen showLoginButton={false} />
  );
};

export default React.memo(Auth0CallbackPage);